import { Controller } from '@hotwired/stimulus';
import { showModal, hideModal } from '../utils/modal';
import Cookies from 'js-cookie';

export default class extends Controller {
  initialize() {
    if (!Cookies.get('fpu_workbook')) {
      showModal('fpu-workbook', { disableFocus: true });
      this.hasSeenModal();
    }
  }

  close() {
    event.cancelBubble = true;
    hideModal('fpu-workbook');
  }

  hasSeenModal() {
    Cookies.set('fpu_workbook', Date.now(), { expires: 365 });
  }
}
